<span class="type">{{ data[category].type | translate }}</span>
<ul class="list">
	@for (option of data[category].options; track $index) {
		<li>{{ option | translate }}</li>
	}
</ul>
